<template>
  <h1 class="report__menu--logo" :class="[target, {'black' : isLogoWhite && isABPlan && target !== 'report'}]">
    <router-link :to="{ name: 'home' }">
      <i class="icon icon--logo-white-min"></i>
      <i v-if="isLogoWhite" class="icon icon--logo-beusable-only-white"></i>
      <i v-else class="icon icon--logo-new"></i>

      <template v-if="!isABPlan">
        <h2 :class="{'white': isLogoWhite}">UX Heatmap</h2>
      </template>
      <template v-else>
        <i class="icon icon-x"></i>
        <i class="icon company" :class="companyName"></i>
      </template>

      <i v-if="target === 'report' && applyData.bAMP" class="icon icon--amp-logo"></i>
    </router-link>
    <i class="icon icon--abplan--logo" v-if="isABPlan"></i>
  </h1>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    target: {
      type: String,
      default: 'report'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'applyData',
      'userData',
      'isABPlan'
    ]),
    companyName () {
      if (this.userData.userId.indexOf('wirelink') > -1) {
        return 'wirelink'
      }
      return 'siemens'
    },
    isLogoWhite () {
      return this.target === 'report' || this.companyName === 'wirelink'
    }
  },
  created () {
  }
}
</script>
<style lang="scss" scoped>
.report__menu--logo {
  position: relative;
  margin-top: 15px;
  margin-left: 15px;
  white-space: nowrap;

  &.black {
    background-color: #1b1b1b;
    width: 180px;
    margin-top: 5px;
    margin-left: 5px;
    padding: 10px;
    border-radius: 5px;
  }

  &.report {
    margin-top: 18px;
    margin-left: 18px;

    &.black {
      width: 160px;
    }
  }

  a {
    display: block;
    .icon--logo-white-min {
      position: absolute;
      top: 0px;
      left: 0px;
      opacity: 0;
    }

    h2 {
      margin-top: 5px;
      font-family: "rubrik-new";
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: -0.22px;
      color: #ec0047;

      &.white {
        color: #ffffff;
      }
    }
  }

  .icon--abplan--logo {
    display: inline-block;
    margin-top: 8px;
  }

  .icon-x {
    display: inline-block;
    margin-left: 8px;
    width: 20px;
    height: 20px;
  }

  .company {
    display: block;

    margin-top: 5px;
    &.wirelink {
      width: 132px;
      height: 29px;
      background-size: 132px;
      background-image: url(../../assets/img/abplan/logo_wirelink.png);
      margin-left: -6px;
    }

    &.siemens {
      width: 132px;
      height: 29px;
      background-size: 132px;
      background-image: url(../../assets/img/abplan/siemens.svg);
    }
  }
}
</style>
